import { LoginForm } from "../../features/auth";

export default LoginForm;
